/* eslint-disable */
import { useState } from "react";
import TextField from "@mui/material/TextField";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  FormControl,
  Grid,
  Box,
  Button,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "../common/components/LocalizationProvider";
import AwaitDialog from "../common/components/AwaitDialog";
import SuccessDialog from "../common/components/SuccessDialog";
import { useEffectAsync } from "../reactHelper";
import { formatDate } from "../common/util/formatter";
import SettingsMenu from "./components/SettingsMenu";
import PageLayout from "../common/components/PageLayout";
import { errorsActions } from "../store";
import useSettingsStyles from './common/useSettingsStyles';

const WhatsappPage = () => {
  const { classes } = useSettingsStyles();
  const t = useTranslation();
  const dispatch = useDispatch();

  const server = useSelector((state) => state.session.server);

  const [awaiting, setAwaiting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [reconfigure, setReconfigure] = useState(false);
  const [starting, setStarting] = useState(false);
  const [started, setStarted] = useState(false);

  const [qrImage, setQrImage] = useState("/images/whatsapp/loading.gif");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  useEffectAsync(async () => {
    const intervalId = setInterval(async () => {
      const baseUrl = server.attributes.wpp_url;
      const apiKey = server.attributes.wpp_apiKey;
      const sessionId = server.attributes.wpp_sessionId;

      if (!started) {
        if (baseUrl && apiKey && sessionId) {
          const responseStatus = await fetch(
            `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/qrcode`
          );

          if (responseStatus.ok) {
            const resultStatus = await responseStatus.json();
            if (
              resultStatus.message === "O usuário já está logado no sistema"
            ) {
              setQrImage("/images/whatsapp/online.png");
              setStarted(true);
              setStarting(false);
              setReconfigure(false);
            } else if (resultStatus.message === "QRcode buscado") {
              setQrImage(resultStatus.qrcode);
              setStarting(false);
              setReconfigure(false);
            } else {
              setQrImage("/images/whatsapp/offline.png");
              setStarted(false);
              setStarting(false);
              setReconfigure(false);
            }
          } else {
            if (!reconfigure) {
              await handleReconfigure();
            } else {
              if (!starting) {
                await handleStart();
              } else {
                const responseQR = await fetch(
                  `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/qrcode`
                );

                if (responseQR.ok) {
                  const result = await responseQR.text();
                  setQrImage(result.qrcode);
                }
              }
            }
          }
        } else {
          setQrImage("/images/whatsapp/exclamation.png");
        }
      }
    }, 5000);
    return () => clearInterval(intervalId);
  }, [server]);

  const handleReconfigure = async () => {
    const baseUrl = server.attributes.wpp_url;
    const apiKey = server.attributes.wpp_apiKey;
    const sessionId = server.attributes.wpp_sessionId;

    const response = await fetch(
      `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/reconfigurar`,
      { method: "DELETE" }
    );

    if (response.ok) {
      setTimeout(() => {
        setQrImage("/images/whatsapp/loading.gif");
        setStarted(false);
        setReconfigure(true);
        setStarting(false);
      }, "5000");
    }
  };

  const handleStart = async () => {
    const baseUrl = server.attributes.wpp_url;
    const apiKey = server.attributes.wpp_apiKey;
    const sessionId = server.attributes.wpp_sessionId;

    const response = await fetch(
      `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/run`,
      { method: "POST" }
    );

    if (response.ok) {
      const result = await response.json();
      if (result.message === "Instância iniciada com sucesso!") {
        setTimeout(() => {
          setQrImage("/images/whatsapp/loading.gif");
          setReconfigure(true);
          setStarting(true);
          setStarted(false);
        }, "5000");
      }
    }
  };

  const handleSend = async () => {
    setAwaiting(true);
    const baseUrl = server.attributes.wpp_url;
    const apiKey = server.attributes.wpp_apiKey;
    const sessionId = server.attributes.wpp_sessionId;

    if (baseUrl && apiKey && sessionId) {
      if (phone && message) {
        const response = await fetch(
          `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/send`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              phone,
              message,
            }),
          }
        );

        if (response.ok) {
          setPhone("");
          setMessage("");
          setAwaiting(false);
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, "3000");
        } else {
          setAwaiting(false);
          dispatch(errorsActions.push(await response.text()));
        }
      } else {
        setAwaiting(false);
        dispatch(errorsActions.push(`${t("fieldRequired")}`));
      }
    } else {
      setAwaiting(false);
      dispatch(errorsActions.push(`${t("errorTitle")} ${t("serverTitle")}`));
    }
  };

  const handleRestart = async () => {
    try {
      setQrImage("/images/whatsapp/loading.gif");
      await handleReconfigure();
    } catch (error) {
      dispatch(errorsActions.push(error.message));
    }
  };

  return (
    <PageLayout
      menu={<SettingsMenu />}
      breadcrumbs={["userAdmin", "sharedWhatsapp"]}
    >
      <Container maxWidth="ls" className={classes.container}>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box display="flex" alignItems="center" gap={1}>
              <NewReleasesIcon color="white" />
            <Typography variant="subtitle1">
              Aponte seu celular para essa tela para capturar o código.
            </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <Box sx={{ mb: 12 }}>
                  <img
                    src={qrImage}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Typography variant="subtitle1">
                  {t("whatsappSendMessage")}
                </Typography>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    margin="normal"
                    value={phone || ""}
                    type="number"
                    onChange={(event) => setPhone(event.target.value)}
                    label={t("sharedWhatsapp")}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    margin="normal"
                    value={message || ""}
                    rows={3}
                    multiline
                    onChange={(event) => setMessage(event.target.value)}
                    label={t("commandMessage")}
                    maxRows={3}
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Button
                    type="button"
                    color="primary"
                    variant="outlined"
                    onClick={() => handleSend()}
                  >
                    {t("commandSend")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <FormControl fullWidth margin="normal">
          <div className={classes.buttons}>
            <Button
              type="button"
              color="primary"
              variant="contained"
              onClick={handleRestart}
            >
              {`${t("sharedRestart")} QR`}
            </Button>
          </div>
        </FormControl>
      </Container>
      <AwaitDialog style={{ transform: "none" }} open={awaiting} />
      <SuccessDialog style={{ transform: "none" }} open={success} />
    </PageLayout>
  );
};

export default WhatsappPage;
